import React, { useEffect, useRef } from "react";
import { createBrowserHistory } from "history";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { removeInsignificantZero } from "../../Utilities";
import { RaiseNewRequestButton, IncentiveCertificate } from "../../Components";
import { useHardCode } from "../../hooks";

export const RefundThankYou = () => {
  const history = createBrowserHistory();
  const navigate = useNavigate();
  const storeConfigState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isImmaculateVegan =
    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.immaculate_vegan;
  const isUnfurl =
    SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.unfurl;
  /* browser back button handler */
  useEffect(() => {
    return history.listen(() => {
      if (history.action === "POP") {
        navigate("/");
      }
    });
  }, [history, navigate]);

  return (
    <main className="p13 choose">
      <div className="saara__container">
        <div className="p13__row">
          {refundSettingsState.refundReviewRoute ===
          "KEEP_THE_ITEM_SHOP_LATER" ? (
            <IncentiveCertificateContainer />
          ) : (
            <>
              <div className="p13__content">
                <div className="p13__left">
                  <h1 className="p13__title">
                    {refundSettingsState.thankYouHeading}
                  </h1>
                  <div className="mobile_show ">
                    <div className="p13__content  ">
                      <div className="p13__right saara-d-none">
                        <h2 className="p13__right_title">
                          {refundSettingsState.thankYouCardHeading}
                        </h2>
                        <div className="p13__right_circle">
                          <span className="p13__right_price">
                            {productDetailsState.currency}
                            {removeInsignificantZero(
                              parseFloat(refundSettingsState?.totalRefund)
                            )}
                          </span>
                          <span className="p13__right_action">
                            {refundSettingsState.keepTheItemAmountDesc}
                          </span>
                        </div>
                        <img
                          src="assets/sbg.webp"
                          alt=""
                          className="p13__right_img"
                        />
                      </div>
                    </div>
                    {isImmaculateVegan && (
                      <>
                        <p className="p13__desc p13__desc-1">
                          Thank you for submitting your return. Your return
                          request ID is {otherSettingsState.ran}.
                        </p>
                        <p className="p13__desc p13__desc-1">
                          Please look out for an email in the next 1 working day
                          with next steps.
                        </p>

                        <p className="p13__desc p13__desc-1">
                          Please check your junk inbox if you do not receive the
                          email within this timeframe.
                        </p>
                      </>
                    )}
                    {isUnfurl && (
                      <>
                        <p className="p13__desc p13__desc-1">
                          Thank you for submitting your return. Your return
                          request ID is {otherSettingsState.ran}.
                        </p>
                        <p className="p13__desc p13__desc-1">
                        Your return request has been submitted. Please allow 1-2 working days for processing.
                        </p>

                        <p className="p13__desc p13__desc-1">
                        If you are returning multiple items please continue using the link below. We will be in touch shortly
                        </p>
                      </>
                    )}
                    <p className="p13__desc p13__desc-1">
                      {SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                        ? PURE_FEMALE_TRANSLATION.common_text.final_submission
                        : isImmaculateVegan || isUnfurl || refundSettingsState.thankYouDesc}
                    </p>
                    {isImmaculateVegan ||
                      (storeConfigState.responseMessage?.length > 0 && (
                        <p className="p13__desc p13__desc-2">
                          {storeConfigState.responseMessage?.length > 0
                            ? storeConfigState.responseMessage
                            : refundSettingsState.thankYouDesc}
                        </p>
                      ))}
                  </div>
                  {isImmaculateVegan && (
                    <>
                      <p className="p13__desc mobile_hide p13__desc-1">
                        Thank you for submitting your return. Your return
                        request ID is {otherSettingsState.ran}.
                      </p>
                      <p className="p13__desc mobile_hide p13__desc-1">
                        Please look out for an email in the next 1 working day
                        with next steps.
                      </p>

                      <p className="p13__desc mobile_hide p13__desc-1">
                        Please check your junk inbox if you do not receive the
                        email within this timeframe.
                      </p>
                    </>
                  )}
                  {isUnfurl && (
                    <>
                      <p className="p13__desc mobile_hide p13__desc-1">
                        Thank you for submitting your return. Your return
                        request ID is {otherSettingsState.ran}.
                      </p>
                      <p className="p13__desc mobile_hide p13__desc-1">
                        Your return request has been submitted. Please allow 1-2 working days for processing.
                      </p>

                      <p className="p13__desc mobile_hide p13__desc-1">
                        If you are returning multiple items please continue using the link below. We will be in touch shortly
                      </p>
                    </>
                  )}
                  <p className="p13__desc mobile_hide p13__desc-1">
                    {SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female
                      ? PURE_FEMALE_TRANSLATION.common_text.final_submission
                      : isImmaculateVegan || isUnfurl || refundSettingsState.thankYouDesc}
                  </p>
                  {isImmaculateVegan ||
                    (storeConfigState.responseMessage?.length > 0 && (
                      <p className="p13__desc mobile_hide p13__desc-2">
                        {storeConfigState.responseMessage?.length > 0
                          ? storeConfigState.responseMessage
                          : refundSettingsState.thankYouDesc}
                      </p>
                    ))}
                  <div
                    className="remove-margin btns shop-more-btn "
                    style={{ marginBottom: "0 !important" }}
                  >
                    {SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female || (
                      <div className="shop-more-btn-1">
                        <a
                          href={`${storeConfigState.baseURL}`}
                          className="saara_custom_btn shop_more_btn saara__btn btn__back back-page"
                        >
                          {
                            storeConfigState?.themeConfig
                              ?.continue_shopping_button_label
                          }
                        </a>
                      </div>
                    )}
                    <RaiseNewRequestButton />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
};

const IncentiveCertificateContainer = () => {
  const storeConfigState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME } = useHardCode();
  return (
    <>
      <div className="p13__content">
        <div className="p13__left">
          <h1 className="p13__title">
            {storeConfigState?.themeConfig?.incentive_accept_left_title}
          </h1>
          <div className="">
            {/*Message for Keep the Item Shop Later */}
            <p className="p13__desc p13__desc-3">
              {storeConfigState?.themeConfig?.incentive_accept_left_content}
            </p>
            <p className="p13__desc p13__desc-3">
              {`${storeConfigState?.themeConfig?.we_have_added} ${productDetailsState.currency}${refundSettingsState?.incentive?.keep_item_store_credits.refund_value} ${storeConfigState?.themeConfig?.as_store_credit}`}
            </p>
          </div>
          <div className="btns shop-more-btn">
            {SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female || (
              <div className="shop-more-btn-1">
                <a
                  href={`${storeConfigState.baseURL}`}
                  className="saara_custom_btn shop_more_btn saara__btn btn__back back-page"
                >
                  {
                    storeConfigState?.themeConfig
                      ?.continue_shopping_button_label
                  }
                </a>
              </div>
            )}
            <RaiseNewRequestButton />
          </div>
        </div>
      </div>
      <IncentiveCertificate
        storeConfigState={storeConfigState}
        productDetailsState={productDetailsState}
      />
    </>
  );
};
